import Dialpad from './Dialpad.component';

export * from './Dialpad.component';
export default Dialpad;